module.exports = __webpack_public_path__ + "img/icon-enterprise.866c1bbe.png";